// Permission slugs the UI reasons about directly. The full catalogue is
// server-driven; only slugs that drive client-side behaviour belong here.
export const VENUES_CREATE_PERMISSION = 'venues:create';
